import { trigger } from '../../common/events.js'
export default {
    methods: {
        createMockReservation(orderData) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            this.$emit('processing', true)
            EcomService.createMockReservation(orderData)
            .then((response) => {
                const { data } = response;

                if (data.success) {
                    if (Array.isArray(data.stamps)) {
                        data.stamps.forEach((row) => this.$store.commit('reservations/updateResourceRule', row));
                    }

                    this.$store.dispatch('reservations/onDateChange', this.date);

                    /*
                    showErrorDialog(_locale('reservation').ucfirst() + ' ' + _locale('succeeded'), false, () => {
                        //location.reload()
                    });
                    */

                    if (orderData.forClient) {
                        this.$_swal({
                            title: '',
                            html: '<h1>' + _locale('reservation').ucfirst() + ' ' + _locale('succeeded') + '</h1>',
                            showCancelButton: false,
                            showDenyButton: true,
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            confirmButtonText: _locale('ok').ucfirst(),
                            denyButtonText: _locale('Add to POS').ucfirst(),
                            preDeny: () => {                            
                                const cookieDate = new Date();
                                const domain = window.location.hostname.split('.').slice(-2).join('.');
                    
                                cookieDate.setTime(cookieDate.getTime()+(1*60*1000));  
                    
                                const cookie = `posAddOrderId=${ data.orderId }; SameSite=strict; Secure; expires=${ cookieDate.toGMTString() }; max-age=60; domain=${ domain }; path=/;`;
                    
                                console.log("Cookie", cookie);

                                document.cookie = cookie;

                                return false;
                            }
                        })
                    }

                    if (!orderData.forClient && data.orderId && data.hash) {
                        EcomService.activateOrder(data.orderId, data.hash)
                    }
                    
                    if (typeof this.onResevationSuccess === 'function') {
                        this.onResevationSuccess()
                    }
                } else {
                    // this could fail because of price > 0 and no privileges
                    if (orderData.forceMockOrder) {
                        this.$_swal({ icon: 'error', html: data.errors.map((err) => `<p>${ _locale(err.message).ucfirst() }</p>`).join('') })
                    } else {
                        const groupDayLimitError = data.errors.filter(row => row.id === 'groupDayLimitError')[0]

                        if (groupDayLimitError) {
                            return this.$_swal({
                                title: groupDayLimitError.message,
                                showCancelButton: true,
                                confirmButtonText: _locale('Proceed to checkout').ucfirst(),
                                cancelButtonText: _locale('cancel').ucfirst()
                            })
                            .then((result) => {
                                if (result.isConfirmed) {
                                    this.addToCart(orderData);
                                }
                            })
                        }
                        
                        this.addToCart(orderData);
                    }
                }
            }).finally(() => this.$emit('processing', false))
        }, // createMockReservation
        addToCart(data, redirect = true) {
            const EcomService = this.$store.getters['ecom/EcomService'];
            this.$emit('processing', true)
            // check reservation type when to use addtocart
            // some reservations are paid afterwards locally
            EcomService.addToCart(data)
            .then((response) => {
                const data = response.data;
                const success = data.products.length > 0 && data.products.reduce((acc, curr) => curr.success === false ? false : acc, true);

                if (success) {
                    if (redirect == false) {
                        this.$store.dispatch('reservations/onDateChange', this.date);
                        
                        trigger(document.body, 'WnCartLoadProducts')
                        
                        if (typeof this.onResevationSuccess === 'function') {
                            this.onResevationSuccess()
                        }
                        
                        this.$emit('processing', false)
                        return;
                    }

                    const isEmbed = this.$store.getters['common/isEmbed'];

                    if (isEmbed) {
                        const postData = {
                            type: 'spacheckout',
                            url: this.$store.getters['common/checkoutUrl']
                        }
                        
                        window.top.postMessage(JSON.stringify(postData), '*');
                    } else {
                        location.href = this.$store.getters['common/checkoutUrl'];
                    }
                } else {
                    this.$emit('processing', false)

                    if (!data.products.length) {
                        this.$_swal({ icon: 'error', title: _locale('The product could not be added to the cart') })
                    } else {
                        const errors = data.products
                        .reduce((acc, curr) => {
                            return [...acc,...curr.errors];
                        }, [])
                        .reduce((acc, curr) => {
                            acc[curr.error] = curr.message;
                            return acc;
                        }, {});
                        this.$_swal({ icon: 'error', html: Object.values(errors).map((err) => `<p>${ _locale(err).ucfirst() }</p>`).join('') })
                    }
                }
            })
        }, // addToCart
    }
}